import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { shallowEqual, type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import context from '@alltrails/context/slices/contextSlice';
import { mapReducer } from '@alltrails/maps/redux/reducer';
import HeatmapsRootState from './HeatmapsRootState';
import { heatmapsReducer } from './heatmapsSlice';

export type PreloadedState = HeatmapsRootState;

export const reducer = combineReducers({
  heatmaps: heatmapsReducer,
  context,
  map: mapReducer
});

export const buildStore = (preloadedState?: PreloadedState) =>
  configureStore({
    reducer,
    preloadedState
  });

export type AppStore = ReturnType<typeof buildStore>;
export type AppDispatch = AppStore['dispatch'];

// these are intended to use within the package only
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<HeatmapsRootState> = (selector: (state: HeatmapsRootState) => any) =>
  useSelector<HeatmapsRootState, any>(selector, shallowEqual);
